import Grid from '@mui/material/Grid';
import Button from '../UI/Button';
import { bimestreKey, diaLetivoExtraKey, diaNaoLetivoKey } from './BimestreContainerMenu';
import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    container: {
        flexGrow: 1,
        padding: '20px',
        marginTop: '10px',
        marginBottom: '10px',

    }
})

const BimestreMenu = ({ menu, setMenu }) => {
    const classes = useStyles();
    return (
        <Grid
            container
            component={Paper}
            spacing={3}
            justifyContent='center'
            className={classes.container}
        >
            <Grid>
                <Button
                    onClick={() => setMenu(bimestreKey)}
                    disabled={menu === bimestreKey}
                >
                    Bimestre
                </Button>
            </Grid>
            <Grid>
                <Button
                    onClick={() => setMenu(diaLetivoExtraKey)}
                    disabled={menu === diaLetivoExtraKey}
                >
                    Dia Letivo Extra
                </Button>
            </Grid>
            <Grid>
                <Button
                    onClick={() => setMenu(diaNaoLetivoKey)}
                    disabled={menu === diaNaoLetivoKey}
                >
                    Dia não Letivo
                </Button>
            </Grid>
        </Grid>
    );
}

export default BimestreMenu;